import React from 'react';
import MusicList from './MusicList';

const MusicFavorites = () => {
  return (
    <MusicList 
      filterMode="favorites"
      showQuickCategoryBar={true}
    />
  );
};

export default MusicFavorites;

